import React from 'react';
import HmongChildMascot, { HmongChildMascotProps, MascotPalette } from './HmongChildMascot';

export type MascotComponent = React.ComponentType<{ size?: number } & Partial<HmongChildMascotProps>>;

export interface MascotDefinition {
    name: string;
    component: MascotComponent;
    defaultSize?: number;
}

const registry = new Map<string, MascotDefinition>();

export function registerMascot(def: MascotDefinition) {
    registry.set(def.name, def);
}

export function getMascot(name?: string): MascotDefinition {
    if (name && registry.has(name)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return registry.get(name)!;
    }
    // Default mascot
    return {
        name: 'hmong-child',
        component: HmongChildMascot,
        defaultSize: 60
    };
}

// Pre-register defaults
registerMascot({ name: 'hmong-child', component: HmongChildMascot, defaultSize: 60 });

// Variant presets for convenience (avoid JSX in .ts file)
export const MascotPresets = {
    hmongWhite: (size?: number) => (props?: Partial<HmongChildMascotProps>) =>
        React.createElement(HmongChildMascot, { size: size ?? 60, variant: 'white', ...(props || {}) }),
    hmongGreen: (size?: number) => (props?: Partial<HmongChildMascotProps>) =>
        React.createElement(HmongChildMascot, { size: size ?? 60, variant: 'green', ...(props || {}) })
};

// Optional easy variant names (no JSX)
const HmongWhiteMascot: MascotComponent = (p) => React.createElement(HmongChildMascot, { ...p, variant: 'white' });
const HmongGreenMascot: MascotComponent = (p) => React.createElement(HmongChildMascot, { ...p, variant: 'green' });
registerMascot({ name: 'hmong-white', component: HmongWhiteMascot, defaultSize: 60 });
registerMascot({ name: 'hmong-green', component: HmongGreenMascot, defaultSize: 60 });

export { HmongChildMascot };
export type { HmongChildMascotProps, MascotPalette };

